import React from 'react';

const STORE_KEY = 'ISSUES_UI_STORE';
export const STORE_CONTEXT = React.createContext(STORE_KEY);
